import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../config/apiConfig";
import { useAuth } from "../../context/AuthProvider";
import WebmasterSidebar from "../../components/WebmasterSidebar";
import Swal from "sweetalert2";

interface ScoreConfig {
  id: string;
  key: string;
  label: string;
  score: number;
  type: string;
}

const PointsSettingsPage: React.FC = () => {
  const { token } = useAuth();
  const [items, setItems] = useState<ScoreConfig[]>([]);
  const [updatedScores, setUpdatedScores] = useState<Record<string, number>>({});
  const [loading, setLoading] = useState<boolean>(true);
  const [saving, setSaving] = useState<boolean>(false);
  const [isCollapsed, setIsCollapsed] = useState<boolean>(() => {
    return localStorage.getItem("sidebarCollapsed") === "true";
  });

  useEffect(() => {
    const fetchScores = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/score-config/all`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const data = await res.json();
        const sortedData = [...(data || [])].sort((a, b) => {
          if (a.type === b.type) return a.label.localeCompare(b.label);
          return a.type === "therapy" ? -1 : 1;
        });
        setItems(sortedData);
      } catch (err) {
        console.error("Eroare la încărcarea scorurilor:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchScores();
  }, [token]);

  const handleScoreChange = (key: string, value: number) => {
    setUpdatedScores((prev) => ({ ...prev, [key]: value }));
    setItems((prev) =>
      prev.map((item) => (item.key === key ? { ...item, score: value } : item))
    );
  };

  const handleSaveAll = async () => {
    setSaving(true);
    const Toast = Swal.mixin({
        toast: true,
        position: "top-end",
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
        didOpen: (toast) => {
          toast.onmouseenter = Swal.stopTimer;
          toast.onmouseleave = Swal.resumeTimer;
        }
      });
    try {
      const requests = Object.entries(updatedScores).map(([key, score]) =>
        fetch(`${API_BASE_URL}/score-config/${key}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ score }),
        })
      );
      await Promise.all(requests);
      setUpdatedScores({});
      Toast.fire({
        icon: "success",
        title: "Punctajele au fost salvate."
      });
    } catch (err) {
      Toast.fire({
        icon: "error",
        title: "Eroare la salvarea punctajelor"
      });
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <p>Se încarcă...</p>;

  return (
    <div className={`dashboard-container ${isCollapsed ? "collapsed" : ""}`}>
      <WebmasterSidebar onCollapseChange={(collapsed) => setIsCollapsed(collapsed)} />

      <div className="page-content">
        <h1 className="page-title">Configurare Puncte Bonus</h1>
        <div className="table-top">
          <div className="page-subtitle">Puncte Bonus</div>
        <div className="table-actions mobile-flex-end">
        <button
          className="primary-btn save-scores"
          onClick={handleSaveAll}
          disabled={Object.keys(updatedScores).length === 0 || saving}
        >
          {saving ? "Se salvează..." : "Salvează toate"}
        </button>
        </div>
        </div>
        <div className="score-table">
          {items.map((item) => (
            <div key={item.key} className="score-row">
              <span className="score-label">{item.label}</span>
              <input
                type="number"
                value={item.score}
                onChange={(e) => handleScoreChange(item.key, parseInt(e.target.value))}
                min={1}
                max={5}
                className="score-input"
              />
            </div>
          ))}
        </div>

       
      </div>
    </div>
  );
};

export default PointsSettingsPage;
